import { render, staticRenderFns } from "./DashConfigDialog.vue?vue&type=template&id=26190ce6&scoped=true"
import script from "./DashConfigDialog.vue?vue&type=script&lang=js"
export * from "./DashConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./DashConfigDialog.vue?vue&type=style&index=0&id=26190ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26190ce6",
  null
  
)

export default component.exports